interface DeferredScriptOptions {
	src: string;
	id: string;
	attributes?: Record<string, string>;
}

/**
 * Loads a script after router is ready and browser is idle.
 * Falls back to setTimeout for browsers without requestIdleCallback support.
 *
 * @param options - Script configuration including src, id, and optional attributes
 */
export function loadScriptDeferred(options: DeferredScriptOptions): void {
	const { src, id, attributes } = options;

	if ('requestIdleCallback' in window) {
		requestIdleCallback(() => injectScript(src, id, attributes), { timeout: 5000 });
	} else {
		setTimeout(() => injectScript(src, id, attributes), 100);
	}
}

function injectScript(src: string, id: string, attributes?: Record<string, string>): void {
	if (document.getElementById(id)) return;

	const script = document.createElement('script');
	script.id = id;
	script.src = src;
	script.async = true;

	if (attributes) {
		Object.entries(attributes).forEach(([key, value]) => script.setAttribute(key, value));
	}

	document.head.appendChild(script);
}
